export const onStopPropagation = (e) => e.stopPropagation();

export const onPreventDefault = (e) => e.preventDefault();
